import React from "react"
import { injectIntl } from "react-intl"
import SideBar from "../../common/layout/sidebar.component"
import GenericListing from "../../common/listing/generic-listing/GenericListing"
import { ObjectType } from "../../state/listing/generic-listing"
import PaymentTabs from "./paymentTabs"

const PaymentListing = () => {
    SideBar.activateMenu("payment")

    return (
        <>
            <PaymentTabs />
            <GenericListing
                objectType={ObjectType.PAYMENTS}
            />
        </>
    )
}

export default injectIntl(PaymentListing)


// WEBPACK FOOTER //
// ./src/payment/listing/paymentListing.tsx